import {defineNuxtPlugin} from "#app";
import {useAuth} from "../composables/auth";

export default defineNuxtPlugin(async () => {
  const { me } = useAuth()

  await me()
})
